import script from "./StripeCheckout.vue?vue&type=script&setup=true&lang=ts"
export * from "./StripeCheckout.vue?vue&type=script&setup=true&lang=ts"

import "./StripeCheckout.vue?vue&type=style&index=0&id=08f3f074&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f3f074"]])

export default __exports__